interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-500 uppercase tracking-[0.2em] text-primary-600">
          <span className="h-px w-6 bg-primary-400" aria-hidden="true"></span>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl font-700 tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}